var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { formatURLDate, parseURLDate } from "../../../shared/utils/dates";
import { GlobalURL } from "@travel/shared/global/utils";
export function createHotelURLRequestParams(_a) {
    var checkIn = _a.checkIn, checkOut = _a.checkOut, roomCount = _a.roomCount, adultCount = _a.adultCount, children = _a.children, currency = _a.currency, campaign = _a.campaign, ad = _a.ad, cid = _a.cid;
    var params = new URLSearchParams();
    if (checkIn) {
        params.append("check-in", typeof checkIn === "string" ? checkIn : formatURLDate(checkIn));
    }
    if (checkOut) {
        params.append("check-out", typeof checkOut === "string" ? checkOut : formatURLDate(checkOut));
    }
    if (roomCount) {
        params.append("rooms", String(roomCount));
    }
    if (adultCount) {
        params.append("adults", String(adultCount));
    }
    if (children === null || children === void 0 ? void 0 : children.length) {
        params.append("children", children.map(function (child) { return String(child); }).toString());
    }
    if (currency) {
        params.append("currency", currency);
    }
    if (campaign) {
        params.append("campaign", encodeURIComponent(campaign));
    }
    if (ad) {
        params.append("ad", encodeURIComponent(ad));
    }
    if (cid) {
        params.append("cid", encodeURIComponent(cid));
    }
    return params;
}
export var createHotelListURL = GlobalURL(function (request) {
    var _a, _b, _c;
    var location = request.location, _d = request.checkIn, checkIn = _d === void 0 ? "today" : _d, _e = request.checkOut, checkOut = _e === void 0 ? "tomorrow" : _e, _f = request.roomCount, roomCount = _f === void 0 ? 1 : _f, _g = request.adultCount, adultCount = _g === void 0 ? 2 : _g, children = request.children, rest = __rest(request, ["location", "checkIn", "checkOut", "roomCount", "adultCount", "children"]);
    if (!location)
        return "";
    var checkInDate = checkIn instanceof Date ? checkIn : parseURLDate(checkIn);
    var checkOutDate = checkOut instanceof Date ? checkOut : parseURLDate(checkOut);
    var isHotel = location.type === "hotel";
    var searchParams = createHotelURLRequestParams(isHotel ? request : rest);
    var _h = __read((_a = String(location === null || location === void 0 ? void 0 : location.id)) === null || _a === void 0 ? void 0 : _a.split("x"), 2), lat = _h[0], lng = _h[1];
    var locationID = (location === null || location === void 0 ? void 0 : location.type) === "geo"
        ? "".concat(((_b = location === null || location === void 0 ? void 0 : location.coords) === null || _b === void 0 ? void 0 : _b.latitude) || lat, "x").concat(((_c = location === null || location === void 0 ? void 0 : location.coords) === null || _c === void 0 ? void 0 : _c.longitude) || lng)
        : location === null || location === void 0 ? void 0 : location.id;
    return isHotel
        ? "/hotels/property/".concat(locationID, "?").concat(searchParams)
        : "/hotels/".concat(location.type, "/").concat(locationID, "/").concat(formatURLDate(checkInDate), "/").concat(formatURLDate(checkOutDate), "/").concat(roomCount, "/").concat(adultCount, "/").concat((children === null || children === void 0 ? void 0 : children.toString()) || "", "?").concat(searchParams);
});
export var createHotelURL = createHotelListURL;
export function parseHotelRouteParam(value) {
    if (!value)
        return;
    if (Array.isArray(value))
        return value;
    return decodeURIComponent(value || "").split(",");
}
export function createHotelContractURL(_a) {
    var hotelID = _a.hotelID, bestDeal = _a.bestDeal, request = __rest(_a, ["hotelID", "bestDeal"]);
    var params = createHotelURLRequestParams(request);
    if (hotelID) {
        params.append("hotel-id", hotelID);
    }
    if (bestDeal) {
        params.append("best", "1");
    }
    return "/cart/checkout/".concat(request.id, "?").concat(params.toString());
}
